import { api, upload } from "./client";

export interface CheckinDay {
  day: number;
  award: number;
  isCheckIn: boolean;
}
export interface CheckinInfo {
  list: CheckinDay[];
  isCheckIn?: boolean;
  btn?: boolean;
}
export interface MessageRecord {
  id?: string | number;
  title: string;
  content: string;
  create_time: string | number;
}
export interface ExchangeConfig {
  scoreRate: number;
  currencyRate: number;
  scoreToMoneyStart: number;
  moneyToScoreStart: number;
}
export interface PointRecord {
  type: string | number;
  create_time: string;
  before_amount: number;
  after_amount: number;
}
export interface PrizeRecord {
  id: string | number;
  type: string | number;
  count: number;
  phone?: string;
  name?: string;
  create_time?: string;
  icon_img?: string;
  icon_img_full?: string;
}
export interface LotteryRecord {
  type: string | number;
  count: number;
  create_time: string | number;
  create_time_r: string;
  icon_img?: string;
  icon_img_full?: string;
}
export interface CouponRecord {
  id?: string | number;
  coupon_quota: number | string;
}
export interface CdkRecord {
  money: number | string;
  code: string;
  use_time: string;
}
export interface RedPacketRecord {
  money: number | string;
  code: string;
  use_time: string;
}
export interface ExchangeRecord {
  state: string | number;
  exchange: number | string;
  consume: number | string;
  time: string;
}

export interface NoticeContent {
  content: string;
  update_time?: string | number;
}

export interface CarouselItem {
  url: string;
  url_full?: string;
  type?: string | number;
  jump_url?: string;
}

export const engagementApi = {
  notice: (type: number) =>
    api.post<NoticeContent>("/api/v1/notice", { type }),
  carousel: async () =>
    (
      await api.post<{ list: CarouselItem[] }>("/api/v1/carousel/images")
    ).list.filter((item) => Boolean(item.url_full || item.url)),
  checkin: () => api.post<CheckinInfo>("/api/v2/checkin"),
  submitCheckin: () => api.post("/api/v2/user/checkin"),
  messages: async () =>
    (await api.post<{ list: MessageRecord[] }>("/api/v2/message")).list,
  exchangeConfig: () => api.get<ExchangeConfig>("/api/v2/ex/conf"),
  exchange: (type: 1 | 2, amount: number) =>
    api.post("/api/v2/score/exchange", { type, amount }),
  pointRecords: async () =>
    (
      await api.post<{ list: PointRecord[] }>("/api/v2/funds/record", {
        type: 2,
        page: 1,
        num: 30,
      })
    ).list,
  updateName: (userName: string) =>
    api.post("/api/v2/set/info", { type: 1, userName }),
  updatePassword: (oldPass: string, newPass: string, againNewPass: string) =>
    api.post("/api/v2/set/info", { type: 2, oldPass, newPass, againNewPass }),
  updateAvatar: (file: File) => {
    const body = new FormData();
    body.append("type", "3");
    body.append("photo", file);
    return upload("/api/v2/set/info", body);
  },
  userDetails: () => api.post<Record<string, unknown>>("/api/v2/get/user"),
  customerService: () => api.post<{ url: string }>("/api/v2/customer/service"),
  downloadUrls: () =>
    api.get<{ android?: string; ios?: string }>("/api/v1/down/url"),
  prizes: async () =>
    (await api.get<{ list: PrizeRecord[] }>("/api/v2/prize/list")).list,
  drawPrize: () => api.post<PrizeRecord>("/api/v2/win/prize"),
  winners: async () =>
    (await api.post<{ list: PrizeRecord[] }>("/api/v2/win/record")).list,
  lotteryRecords: async (page = 1, num = 10) =>
    (
      await api.post<{ list: LotteryRecord[] }>("/api/v2/lottery/record", {
        page,
        num,
      })
    ).list,
  coupons: async (type: 1 | 2) =>
    (
      await api.post<{ list: CouponRecord[] }>("/api/v2/coupon/list", {
        type,
        page: 0,
        num: 30,
      })
    ).list,
  redeemCdk: (cdk: string) =>
    api.post<{ money: number }>("/api/v2/jdk/exchange", { cdk }),
  cdkRecords: () =>
    api.post<{ list: CdkRecord[]; allExchangeAmount: number }>(
      "/api/v2/exchange/record",
      { page: 1, num: 30 },
    ),
  redPacketRecords: async () =>
    (
      await api.post<{ list: RedPacketRecord[] }>("/api/v2/red-pack/record", {
        page: 1,
        num: 100,
      })
    ).list,
  openRedPacket: (cdk: string) =>
    api.post<{ amount: number }>("/api/v2/open/red-pack", { cdk }),
  exchangeRecords: async () =>
    (
      await api.post<{ list: ExchangeRecord[] }>("/api/v2/exc/record", {
        page: 1,
        num: 100,
      })
    ).list,
};
